import { PackagesActionTypes } from "./constants";

const INIT_STATE = {
  list: [],
  total: 0,
  one: null,
  loading: false,
};

interface PackageCreate {
  name: string;
  pack: { [countryCode: string]: number };
}

interface PackagesData {
  items?: any[];
  total?: number;
}

interface GetPackagesData {
  id: string;
}

interface PackagesActionType {
  type:
    | PackagesActionTypes.GET_LIST_PACKAGES
    | PackagesActionTypes.GET_LIST_PACKAGES_ERROR
    | PackagesActionTypes.GET_LIST_PACKAGES_SUCCESS
    | PackagesActionTypes.CREATE_PACKAGE
    | PackagesActionTypes.CREATE_PACKAGE_SUCCESS
    | PackagesActionTypes.CREATE_PACKAGE_ERROR
    | PackagesActionTypes.GET_PACKAGE
    | PackagesActionTypes.GET_PACKAGE_SUCCESS
    | PackagesActionTypes.GET_PACKAGE_ERROR
    | PackagesActionTypes.UPDATE_PACKAGE
    | PackagesActionTypes.UPDATE_PACKAGE_SUCCESS
    | PackagesActionTypes.UPDATE_PACKAGE_ERROR
    | PackagesActionTypes.DELETE_PACKAGE
    | PackagesActionTypes.DELETE_PACKAGE_SUCCESS
    | PackagesActionTypes.DELETE_PACKAGE_ERROR;
  payload: {
    actionType?: string;
    data?: PackagesData;
    createData?: PackageCreate;
    getPackage?: GetPackagesData;
    error?: string;
    packageCreateError?: string;
    updated: false;
    refreshList: false;
  };
}

interface State {
  list?: any[];
  total?: number;
  one?: any;
  loading?: boolean;
  value?: boolean;
}

const Packages = (
  state: State = INIT_STATE,
  action: PackagesActionType
): any => {
  switch (action.type) {
    case PackagesActionTypes.GET_PACKAGE:
      return {
        ...state,
        list: [],
        one: null,
        loading: true,
        error: "",
        packageCreateError: "",
        total: 0,
        updated: false,
      };
    case PackagesActionTypes.GET_PACKAGE_SUCCESS:
      switch (action.payload.actionType) {
        case PackagesActionTypes.GET_PACKAGE: {
          return {
            ...state,
            list: [],
            loading: false,
            total: 0,
            one: action.payload.data,
            error: "",
            packageCreateError: "",
            updated: false,
          };
        }
        default:
          return { ...state };
      }

    case PackagesActionTypes.GET_PACKAGE_ERROR:
      switch (action.payload.actionType) {
        case PackagesActionTypes.GET_PACKAGE: {
          return {
            ...state,
            list: [],
            loading: false,
            total: 0,
            one: null,
            error: action.payload.error,
            packageCreateError: action.payload.error,
            updated: false,
          };
        }
        default:
          return { ...state };
      }

    case PackagesActionTypes.CREATE_PACKAGE:
      return {
        ...state,
        list: [],
        one: null,
        loading: true,
        error: "",
        packageCreateError: "",
        total: 0,
      };
    case PackagesActionTypes.CREATE_PACKAGE_SUCCESS:
      switch (action.payload.actionType) {
        case PackagesActionTypes.CREATE_PACKAGE: {
          return {
            ...state,
            list: [],
            loading: false,
            total: 0,
            one: action.payload.data,
            error: "",
            packageCreateError: "",
          };
        }
        default:
          return { ...state };
      }

    case PackagesActionTypes.CREATE_PACKAGE_ERROR:
      switch (action.payload.actionType) {
        case PackagesActionTypes.CREATE_PACKAGE: {
          return {
            ...state,
            list: [],
            loading: false,
            total: 0,
            one: null,
            error: action.payload.error,
            packageCreateError: action.payload.error,
          };
        }
        default:
          return { ...state };
      }

    case PackagesActionTypes.UPDATE_PACKAGE:
      return {
        ...state,
        list: [],
        one: null,
        loading: true,
        error: "",
        packageCreateError: "",
        total: 0,
      };
    case PackagesActionTypes.UPDATE_PACKAGE_SUCCESS:
      switch (action.payload.actionType) {
        case PackagesActionTypes.UPDATE_PACKAGE: {
          return {
            ...state,
            list: [],
            loading: false,
            total: 0,
            one: action.payload.data,
            error: "",
            packageCreateError: "",
            updated: true,
          };
        }
        default:
          return { ...state };
      }

    case PackagesActionTypes.UPDATE_PACKAGE_ERROR:
      switch (action.payload.actionType) {
        case PackagesActionTypes.UPDATE_PACKAGE: {
          return {
            ...state,
            list: [],
            loading: false,
            total: 0,
            one: null,
            error: action.payload.error,
            packageCreateError: action.payload.error,
          };
        }
        default:
          return { ...state };
      }

    case PackagesActionTypes.GET_LIST_PACKAGES_SUCCESS:
      switch (action.payload.actionType) {
        case PackagesActionTypes.GET_LIST_PACKAGES: {
          return {
            ...state,
            list: action.payload.data.items,
            loading: false,
            total: action.payload.data.total,
            one: null,
            error: "",
            packageCreateError: "",
            updated: false,
            refreshList: false,
          };
        }
        default:
          return { ...state };
      }

    case PackagesActionTypes.GET_LIST_PACKAGES_ERROR:
      switch (action.payload.actionType) {
        case PackagesActionTypes.GET_LIST_PACKAGES: {
          return {
            ...state,
            error: action.payload.error,
            list: [],
            total: 0,
            loading: false,
            updated: false,
            refreshList: false,
          };
        }
        default:
          return { ...state };
      }

    case PackagesActionTypes.GET_LIST_PACKAGES:
      return {
        ...state,
        loading: true,
        list: [],
        total: 0,
        one: null,
        error: "",
        packageCreateError: "",
        updated: false,
        refreshList: false,
      };
    case PackagesActionTypes.DELETE_PACKAGE:
      return {
        ...state,
        refreshList: false,
      };
    case PackagesActionTypes.DELETE_PACKAGE_SUCCESS:
      switch (action.payload.actionType) {
        case PackagesActionTypes.DELETE_PACKAGE: {
          return {
            ...state,
            refreshList: true,
          };
        }
        default:
          return { ...state };
      }

    case PackagesActionTypes.DELETE_PACKAGE_ERROR:
      switch (action.payload.actionType) {
        case PackagesActionTypes.DELETE_PACKAGE: {
          return {
            ...state,
            error: action.payload.error,
            refreshList: false,
          };
        }
        default:
          return { ...state };
      }
    default:
      return { ...state };
  }
};

export default Packages;
